import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {isWindows} from '~/utils/platform';

import './index.scss';

const propTypes = {
  rect: PropTypes.object.isRequired,
  isInSelectionArea: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func
};

/**
 *
 * Provides context for DesignIcons to know which canvas is currently being rendered to.
 * @extends {Component<PropTypes.InferProps<typeof propTypes>>}
 *
 * */
export default class BoundingBox extends Component {
  static propTypes = propTypes;

  originalPosition = {};

  handleClick = e => {
    e.preventDefault();
    const toggle = this.getModifierKeys(e);
    this.originalPosition = {x: e.clientX, y: e.clientY};

    if (!this.props.isSelected || toggle) {
      this.props.onSelect(toggle);
    }
  };

  handleMouseUp = e => {
    e.preventDefault();
    const toggle = this.getModifierKeys(e);

    if (
      !toggle &&
      e.clientX === this.originalPosition.x &&
      e.clientY === this.originalPosition.y
    ) {
      this.props.onSelect(toggle);
    }
  };

  getModifierKeys = e => {
    if (isWindows()) {
      return e.shiftKey || e.metaKey || e.ctrlKey;
    }
    return e.shiftKey || e.metaKey;
  };

  render() {
    const {isInSelectionArea, isSelected} = this.props;
    const className = classnames('ndx-BoundingBox', {
      isInSelectionArea,
      isSelected
    });

    return (
      <div
        className={className}
        style={this.props.rect}
        onContextMenu={this.handleClick}
        onMouseDown={this.handleClick}
        onMouseUp={this.handleMouseUp}
        onTouchStart={this.handleClick}
      />
    );
  }
}
